import React from "react";
import {LucideIcon} from "lucide-react";
import {cn} from "./cn";

export interface BadgeProps {
    tone?: "success" | "error" | "warning" | "info" | "neutral" | "primary";
    icon?: LucideIcon;
    children: React.ReactNode;
    className?: string;
}

const tones: Record<NonNullable<BadgeProps["tone"]>, string> = {
    success: "bg-success-tint text-success",
    error: "bg-error-tint text-error",
    warning: "bg-warning-tint text-warning",
    info: "bg-info-tint text-info",
    primary: "bg-primary-tint text-primary",
    neutral: "bg-surface-sunken text-ink-muted border border-border",
};

export const Badge: React.FC<BadgeProps> = ({tone = "neutral", icon: Icon, children, className}) => (
    <span
        className={cn(
            "inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full leading-none",
            tones[tone],
            className
        )}
    >
        {Icon && <Icon size={12} strokeWidth={2.5}/>}
        {children}
    </span>
);
